import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InventoryPanelsComponent } from './panels/inventory-panels.component';
import {AccordionModule} from '../shared/list/details/accordion/accordion.module';
import {DeploymentPipesModule} from '../deployments/pipes/deployment-pipes.module';
import {DesignFactoryModule} from '../shared/designFactory/designFactory.module';
import { HierarchyListComponent } from './hierarchy-list/hierarchy-list.component';
import { OfficesListComponent } from './offices-list/offices-list.component';
import { CdkFixedSizeVirtualScroll, CdkVirtualForOf, CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { NgbCollapse } from '@ng-bootstrap/ng-bootstrap';



@NgModule({
  declarations: [
    InventoryPanelsComponent,
    HierarchyListComponent,
    OfficesListComponent,
  ],
  exports: [
    InventoryPanelsComponent,
    HierarchyListComponent,
    OfficesListComponent,
  ],
  imports: [
    CommonModule,
    AccordionModule,
    DeploymentPipesModule,
    DesignFactoryModule,
    CdkVirtualScrollViewport,
    CdkFixedSizeVirtualScroll,
    CdkVirtualForOf,
    NgbCollapse,
  ]
})
export class InventoryPanelsModule { }
